/*
 Copyright 2019-present wobe-systems GmbH

 Licensed under the Apache License, Version 2.0 (the 'License');
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an 'AS IS' BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
export interface Member {
  id: string;
  email: string;
  username: string;
}
export interface Workspace {
  id: string;
  owner: Member;
  name: string;
  members: Member[];
  flows: string[];
}
export interface WorkspaceState {
  workspaces: Workspace[]
  loading: boolean;
  currentWorkspace: Workspace;
}

export const emptyWorkspace: Workspace = {
  id: '',
  name: '',
  owner: {
    id: '',
    username: '',
    email: '',
  },
  members: [],
  flows: [],
};

export const emptyWorkspaceState: WorkspaceState = {
  workspaces: [],
  loading: false,
  currentWorkspace: emptyWorkspace,
};
